import React  from 'react';
import SuperadminLogin from '../../components/adminlogin/SuperadminLogin'



const AdminLogin = () => {
  return(
    <main className="w-full flex">
     <SuperadminLogin/>
    </main>
  )
}

export default AdminLogin